import { ageLabel, formatAbsoluteDateTime } from '../../../../utils/relative-age';

interface NoteDoneLineProps {
  doneAt: string;
  doneByName: string | null;
  /** Adds a "reopen" link after the time. */
  onReopen?: () => void;
}

/** "done by X · 3 days ago", with the exact time on hover. */
export function NoteDoneLine({ doneAt, doneByName, onReopen }: NoteDoneLineProps) {
  return (
    <span>
      done by {doneByName ?? 'a former team member'} ·{' '}
      <span title={formatAbsoluteDateTime(doneAt)}>{ageLabel(doneAt)}</span>
      {onReopen && (
        <>
          {' · '}
          <button type="button" className="nb-link-btn" onClick={onReopen}>
            reopen
          </button>
        </>
      )}
    </span>
  );
}
